import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DSText } from '@engenharia/ds-react';
import { Box } from '@material-ui/core';
import { FiChevronLeft } from 'react-icons/fi';

import Logo from '../../components/molecules/Logo';
import mailEmoji from '../../assets/icons/mail-emoji.svg';
import { Container, Card } from './styles';
import Button from '../../components/atoms/Button';
import Header from '../../components/Header';

const ResetPassword = ({ status = 'sent' }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const goLogin = (event) => {
    history.push('/accounts/sign_in');
    event.preventDefault();
  };

  return (
    <>
      <Header positionFixed />
      <Container>
        <Logo />
        <Box mx={2} my={8} component={Card}>
          <img src={mailEmoji} alt={t(`mailStatus.${status}.title`)} />
          <DSText variant="h3" color="primary">
            {t(`mailStatus.${status}.title`)}
          </DSText>
          <Box m={3}>
            <DSText variant="body2">{t(`mailStatus.${status}.subtitle`)}</DSText>
          </Box>

          <Button startIcon={<FiChevronLeft />} mt={4} fullWidth onClick={goLogin} color="primary">
            {t('mailStatus.button')}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default ResetPassword;
